import {Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatSidenavModule} from '@angular/material/sidenav';
import { ChatService } from '../../../services/chat.service';
import {SideBarService} from '../../../services/sidebar.service';
import { v4 as uuidv4 } from 'uuid';

@Component({
    selector: 'fyxt-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    standalone: true,
    imports: [MatSidenavModule, MatIcon, MatButtonModule]
})
export class MainComponent {

    constructor(
        public chatService: ChatService,
        public sideBarService: SideBarService,

    ) {

    }

    createNewChat(){
        this.chatService.messagesSubject.next([]);
        this.sideBarService.currentChat = '';
        this.chatService.currentSessionId = uuidv4();
    }

    toggleMenu() {
        this.sideBarService.loadShortSessionsInfo();
    }
}
